const config = {
    basename: '',
    defaultPath: '/',
    fontFamily: `'Roboto', sans-serif`,
    language: 'en',
    borderRadius: 12
};

export default config;
